module.exports = __webpack_public_path__ + "img/icon-arrow-back.92da9241.svg";